import React from 'react';
import InputContainer from 'components/BoxInputContainer';

export default React.memo(
  ({item, prop, placeholder, custom, disabled, handleChange}) => (
    <InputContainer
      type="text"
      value={item[prop] || ''}
      placeholder={placeholder}
      inputClass="form-control"
      disabled={disabled}
      className="dashed"
      custom={custom}
      handleChange={(event) => {
        if (disabled) {
          return;
        }
        handleChange(prop, event.target.value);
      }}
    />
  )
);
